import React, { useState } from 'react';
import commonStyles from '../Point.module.scss';
import { useSelector } from 'react-redux';
import Title from '../../shared/Title/Title';
import Table from './Table/Table';
import Filters from './Filters/Filters';
import ContentSpinner from '../../shared/Spinner/Spinner';
import { SPORTSBOOK_FILTER_PERIODS, REPORT_HOST } from '../../../constants/defaultValues';
import { getTranslation } from '../../../utils/translation';

const initialPeriod = SPORTSBOOK_FILTER_PERIODS.find(period => period.key === 'today');

export default function SportsBook() {
    const { sportBook, loading } = useSelector(state => state.reports);

    const [dates, setDates] = useState(() => Object.values(initialPeriod.getRange()));
    const [startDate, endDate] = dates;

    const openPage = url => {
        let dateParam = '';
        const startDateUTC = new Date(startDate).getTime();
        const endDateUTC = new Date(endDate).getTime();
        if (startDateUTC !== 0) dateParam += `&startDate=${startDateUTC}`;
        if (endDateUTC !== 0) dateParam += `&endDate=${endDateUTC}`;
        window.open(`${REPORT_HOST}/api/agent/reports/sportsbook/${url}${dateParam}`, '_blank');
    };

    return (
        <>
            <Title title={getTranslation('title.sportsBook')} />
            <Filters
                initialPeriod={initialPeriod}
                startDate={startDate}
                endDate={endDate}
                setDates={setDates}
            />
            <main className={commonStyles.main}>
                {loading ? <ContentSpinner /> : <Table data={sportBook} openPage={openPage} />}
            </main>
        </>
    );
}
